/*
 * Radio selection with free text component.
 * This is a composite based on other components.
 */

import React from 'react';

import {
  Mode
} from '../common.jsx';
import Helpers from './helpers.jsx';

import GridLayout from './grid_layout.jsx'
import RadioSelection from './radio_selection.jsx'
import Selection from './selection.jsx'
import TextField from './text_field.jsx'

export default class RadioSelectionWithFreeText extends GridLayout {

        static get CATEGORY() {
            return 'question';
        }

        static get TYPE() {
            return 'radio_selection_free_text'
        }

        static icon(){
            return <i><i className="fa fa-dot-circle-o"></i> <i className="fa fa-i-cursor"></i></i>;
        }

        static defaultContent(language) {
            let radioComponent = Object.assign(RadioSelection.defaultContent(language), {
                name: 'field_' + Helpers.randomString(),
                deletable: false,
                sortable: false
            });

            let otherOptionTranslationKey = Selection.generateOptionTranslationKey();
            radioComponent.options[0].options.push({value: '0', label: otherOptionTranslationKey});
            radioComponent.translations[language][otherOptionTranslationKey] = I18n.t('field_default_option_other', { scope: 'fe', locale: language });

            let otherComponent = Object.assign(TextField.defaultContent(language), {
                name: radioComponent.name + '_other',
                deletable: false,
                sortable: false
            });
            otherComponent.translations[language] = Object.assign(otherComponent.translations[language], {
                label: '',
                description: '',
                placeholder: I18n.t('please_specify', {scope: 'fe', locale: language})
            });

            return Object.assign(super.defaultContent(language), {
                rows: [
                    [{ span: 1, component: radioComponent }],
                    [{ span: 1, component: otherComponent }]
                ]
            });
        }

        constructor(props) {
            super(props);

            // Ensure old forms have also sortable = false for nested
            // components since that attribute was added later.
            if (this.props.mode == Mode.EDIT) {
                this.constructor.nestedComponents(this.props.content).forEach((c) => {
                    if (typeof c.sortable === 'undefined') {
                        c.sortable = false;
                    }
                });
            }
        }

        viewModeWholeScope() {
            return true;
        }

        renderSettings() {
            // No settings
        }

        componentDidMount() {
            super.componentDidMount();

            if (typeof this.props.updateSettingsCallback == 'function') {
                let content = this.props.content;
                if (content.isNewComponent) {
                    content.rows[0][0].component.isNewComponent = true;
                    content.rows[1][0].component.isNewComponent = true;
                    this.props.updateSettingsCallback(content.id, content, true);
                }
            }

            this.updateOtherTextFieldState();

            jQuery(this.refs.root).on('click', '.options input[type="radio"]', this.updateOtherTextFieldState.bind(this));
            jQuery(this.refs.root).on('click', '.options .clear-radio-selection', this.clearButtonClicked.bind(this));
        }

        updateOtherTextFieldState() {
            if (this.props.mode == Mode.FILL) {
                let otherValue = null;
                let checkedValue = jQuery(this.refs.root).find('.options input[type="radio"]:checked').val();
                let radios = jQuery(this.refs.root).find('.options input[type="radio"]');
                
                if (radios.length > 0) {
                    otherValue = radios.last().val();
                }
                jQuery(this.refs.root).find('input[type="text"][name*="_other"]').prop('disabled', checkedValue != otherValue);
            }
        }

        clearButtonClicked(e) {
            this.clearSelection(e);
            this.updateOtherTextFieldState();
        }
}
